import { FragmentOf, graphql, readFragment } from 'gql.tada'
import Image from 'next/image'
import { forwardRef } from 'react'

import PlayIcon from '@/assets/icons/Play.svg'
import Link from '@/update-monitor/Link'
import { formatDateJPFull } from '@/utils/date-helpers'

import { RubyText } from '../ruby-text'

interface Props {
  challenges: FragmentOf<typeof ChallengeBanner_challenge>[]
}

export const ChallengeBanner = forwardRef<HTMLDivElement, Props>((props, ref): JSX.Element => {
  const challenges = readFragment(ChallengeBanner_challenge, props.challenges)

  if (!challenges || challenges.length === 0) return <></>

  // we only support 1 challenge at a time
  const challenge = challenges[0]

  return (
    <div className="flex flex-col gap-[4px]">
      <Link key={challenge.id} href={`/web/challenges/${challenge.id}`}>
        <div className="flex w-full justify-center bg-[#F4AF4D]">
          <div
            ref={ref}
            className="relative flex h-[143px] max-w-[1020px] flex-col items-center md:h-[85px] md:flex-row md:items-end"
          >
            <div className="mt-[16px] flex h-[59px] w-[197px] items-center justify-center bg-white md:mb-[10px] md:ml-[20px] lg:ml-[40px]">
              <Image
                src={challenge.snap.url}
                width={153}
                height={44}
                className="h-[42px] w-[153px] object-contain"
                alt=""
              />
            </div>

            <div className="mx-[24px] mt-[5px] flex flex-1 flex-col items-center justify-center md:mb-[12px] md:ml-[20px] md:mr-0 md:mt-0 md:items-start">
              <p className="text-[13px] font-bold leading-normal md:text-[13px] lg:text-[14px]">
                {`${formatDateJPFull(challenge.entryStartAt)} - ${formatDateJPFull(challenge.entryEndAt)}`}
                開催
              </p>
              <div className="mt-[4px] text-center text-[16px] font-bold md:text-[20px]">
                <RubyText>{`${challenge.title}はこちら`}</RubyText>
                <span className="ml-[6px] inline-flex h-[18px] w-[18px] items-center justify-center rounded-full bg-black align-middle text-white md:h-6 md:w-6">
                  <PlayIcon width={12} height={11} />
                </span>
              </div>
            </div>

            <div className="ml-[10px] hidden items-end md:mr-[20px] md:flex lg:mr-[16px]">
              <Image
                src="/logimon.png"
                width={181}
                height={76}
                className="md:h-[76px] md:w-[181px]"
                alt=""
              />
            </div>
          </div>
        </div>
      </Link>
    </div>
  )
})
ChallengeBanner.displayName = 'ChallengeBanner'

export const ChallengeBanner_challenge = graphql(`
  fragment ChallengeBanner_challenge on Challenge {
    id
    title
    entryStartAt
    entryEndAt
    snap {
      url
    }
  }
`)
